<template>
  <div class="">
    <!-- TITLE PAGE<br />
    StoryID: {{ $route.params.storyID }}<br />
    PageID: {{ $route.params.pageID }}
  -->
    <div v-if="loading">
      <loading></loading>
    </div>
    <!-- Not loading -->
    <div v-else>
        <!-- There is no error -->
        <v-container text-xs-center>
          <v-row class="headline" align="center" justify="center">
            {{title}}
          </v-row>

          <v-row class="headline" align="center" justify="center">
            <hr width="60%" />
          </v-row>

          <br />
          <v-row class="subheading" align="center" justify="center">
            Authors (so far):{{authors}}
          </v-row>

          <v-row class="subheading" align="center" justify="center">
            Pages: {{pageCount}}
          </v-row>

          <v-row v-if="pageCount > 0" class="subheading mt-4" align="center" justify="center">
            <v-btn  x-large class="success" :to="'/read/'+$route.params.storyID">
              Read the Story
            </v-btn>
          </v-row>

          <v-row v-if="pageCount == 0" class="subheading mt-4" align="center" justify="center">
            <v-btn  x-large class="success" :to="'/read/'+$route.params.storyID+'?first=true'">
              Add the first page!
            </v-btn>
          </v-row>

          <v-row class="headline mt-2 mb-2" align="center" justify="center"  >
            <hr width="60%" />
          </v-row>
          <br />

          <v-row v-if="canEdit" justify="center" align-content="center" align="center">
            <v-col>
              <ReadOnlyLink></ReadOnlyLink>
            </v-col>
            <v-col >
              <EditableLink :storyPass='storyPassword'></EditableLink>
            </v-col>
          </v-row>
          <v-row v-else justify="center" align-content="center" align="center">
            <v-col cols="12" sm="6" lg="4">
              <ReadOnlyLink></ReadOnlyLink>
            </v-col>
          </v-row>

          <v-row class="subheading" align="center" justify="center">
            <router-link :to="{name:'Subscribe', params:{'title':this.title, 'storyID':$route.params.storyID}}">
              Subscribe to updates to this story!
            </router-link>
          </v-row>

        </v-container>
    </div>
    <div v-if="errtext" style="text-align: center;">
        <h2 class="red--text">{{errtext}}</h2>
    </div>
  </div>
</template>

<script>
import config from '../config.js'
import utils from '../utils.js'
import loading from '@/components/Loading.vue'
import ReadOnlyLink from '@/components/ReadOnlyLink.vue'
import EditableLink from '@/components/EditableLink.vue'

export default {
  name: 'TitlePage',
  components: {
    loading, ReadOnlyLink, EditableLink

  },
  data () {
    return {
      errtext: null,
      loading: true,
      title: null,
      authors: null,
      pageCount: null,
      canEdit: false,
      storyPassword: null
    }
  },
  mounted () {
    // Load the current page
    this.loadPage()
  },
  methods: {
    loadPage () {
      this.errtext = null
      const dynFunction = config.getFunctions().httpsCallable('dynFunction')
      const pw = this.$route.query.pw
      if (pw) {
        this.storyPassword = pw
        utils.addStoryPassword(this.$cookies, pw)
      }

      this.storyPasswords = this.$cookies.get('storyPasswords')

      dynFunction({ call: 'getStory', params: this.$route.params, storyPasswords: this.storyPasswords }).then((rc) => {
        console.log('TitlePage MOUNTED: ', rc)
        this.title = rc.data.title
        this.authors = rc.data.authors
        this.pageCount = rc.data.pageCount
        this.loading = false
        this.canEdit = rc.data.canEdit
        this.storyPassword = rc.data.storyPassword // The actual one
      }).catch((err) => {
        console.error('Error getStory: ' + err)
        this.errtext = err
        this.loading = false
      })
    }
  }

  // Load the given page or
  // show an error if the story doesn't exist
  // show something to "write the page" if the page doesn't exist?
}
</script>
